import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { useController } from "react-hook-form";
import * as React from "react";

interface HiddenFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  control: Control<TFieldValues>;
  name: TName;
  value?: string | number;
}

export function HiddenField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ control, name, value }: HiddenFieldProps<TFieldValues, TName>) {
  const { field } = useController({
    control,
    name,
    defaultValue: (value ?? "") as never,
  });

  // Update field value when the value prop changes
  React.useEffect(() => {
    if (value !== undefined && field.value !== value) {
      field.onChange(value);
    }
  }, [value, field, name]);

  // Guard against `field.value` being undefined so the input stays controlled from the first render
  return <input type="hidden" {...field} value={field.value ?? ""} />;
}
